"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialFloorConfigurationState = void 0;
exports.initialFloorConfigurationState = {
    humanReadableName: null,
    floorHeating: {
        type: null,
        material: null,
    },
    floorInsulation: {
        type: null,
        material: null,
    },
    floorScreed: {
        type: null,
        material: null,
    },
    files: {
        nl_be: null,
        fr_be: null,
        nl_nl: null,
        fr_fr: null,
        de_de: null,
        en_en: null,
    },
};
